/*
  File: {file_name}
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import { Button, Tag, Space, Avatar, Alert } from "antd";
import { motion } from "framer-motion";
import { FaCogs } from "react-icons/fa";
import { Agent } from "./types";
import { getNameAbbrevation } from "./service/service";
import parsePhoneNumberFromString from "libphonenumber-js";

interface LeaderBoardProps {
  sortedAgents: Agent[];
  handleManageAgentModalClick: (user: Agent) => void;
}

const formatPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber != undefined) {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "US");
    if (phoneNumberObj) {
      // Format the phone number as (XXX) XXX-XXXX
      return phoneNumberObj.formatNational();
    }
    return phoneNumber;
  }
  return "";
};

const uuidToInteger = (uuid: string): string => {
  // Take the first 8 characters of the UUID and convert to an integer
  // return parseInt(uuid.slice(0, 8), 16).toString();
  return "1";
};

const LeaderBoard: React.FC<LeaderBoardProps> = ({
  sortedAgents,
  handleManageAgentModalClick: handleManageUser,
}) => (
  <div
    className="settings-content"
    style={{
      background: "#000",
      overflowY: "auto",
      width: "auto",
    }}
  >
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div style={{ padding: "5px 20px" }}>
        <h3>Leaderboard of agents</h3>
        <p>View the agents in network sorted in direct referrals</p>
        <Alert
          message="Use the search bar and alphabet selector to pick agent's first name starting with specific letter"
          type="info"
          showIcon
          closable
        />
      </div>

      {sortedAgents.map((agent) => (
        <div
          key={agent.id}
          style={{
            background: "#191919",
            margin: "10px",
            padding: "12px",
            boxShadow: "1px 1px 4px 1px #262626",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar style={{ height: "45px", width: "45px" }}>
                {getNameAbbrevation(agent.first_name, agent.last_name)}
              </Avatar>
              <div
                style={{
                  fontSize: "22px",
                  fontFamily: "ubuntu",
                  fontWeight: "700",
                  marginLeft: "10px",
                }}
              >
                {agent.first_name + " " + agent.last_name}
              </div>
            </div>
            <div style={{ textAlign: "right", marginTop: "8px" }}>
              <Button icon={<FaCogs />} onClick={() => handleManageUser(agent)}>
                Manage Agent
              </Button>{" "}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flex: 1,
              gap: "20px",
              padding: "10px 1px",
            }}
          >
            <Tag
              color={agent.status === "active" ? "green" : "red"}
              style={{
                borderRadius: "0",
                fontFamily: "ubuntu",
              }}
            >
              {agent.status[0].toUpperCase()}
              {agent.status.slice(1)}
            </Tag>
            <Space>
              <span>{agent.email?.toLowerCase()}</span>
            </Space>
            <Space>
              <span> {agent ? formatPhoneNumber(agent.phone_number) : ""}</span>
            </Space>
          </div>
          <div className="agent-details">
            <div className="agent-details-column">
              <div className="agent-label">Login Enabled</div>
              <span>{agent.have_login == true ? "Yes" : "No"}</span>
            </div>
            <div className="agent-details-column">
              <div className="agent-label">Referred Date:</div>
              <span>
                {agent && new Date(agent.referred_date).toLocaleDateString()}
              </span>
            </div>
            <div className="agent-details-column">
              <div className="agent-label">My Direct Referrals</div>
              <span>{agent.referrals?.length}</span>
            </div>
            <div className="agent-details-column">
              <div className="agent-label">Referred By</div>
              <span>
                {agent.referred_by != null
                  ? agent.referred_by?.first_name +
                    " " +
                    agent.referred_by?.last_name
                  : "House Account"}
              </span>
            </div>
          </div>
        </div>
      ))}
    </motion.div>
  </div>
);

export default LeaderBoard;
